import { useEffect, useRef } from "react";

const TrendingPage = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    containerRef.current.innerHTML = "";

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-crypto-coins-heatmap.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      dataSource: "Crypto",
      blockSize: "market_cap_calc",
      blockColor: "change",
      locale: "en",
      symbolUrl: "",
      colorTheme: "dark",
      hasTopBar: false,
      isDataSetEnabled: false,
      isZoomEnabled: true,
      hasSymbolTooltip: true,
      isMonoSize: false,
      autosize: true,
    });

    containerRef.current.appendChild(script);
  }, []);

  return (
    <div className="space-y-4 text-[15px]">

      {/* Header */}
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">Trending</p>
        <h1 className="text-lg font-semibold text-slate-50">Crypto Market Heatmap</h1>
      </div>

      {/* Heatmap Widget */}
      <div
        className="rounded-2xl overflow-hidden border border-slate-800/80 bg-[#0e1629]"
        style={{ height: "600px" }}
      >
        <div
          className="tradingview-widget-container"
          ref={containerRef}
          style={{ height: "100%", width: "100%" }}
        >
          <div
            className="tradingview-widget-container__widget"
            style={{ height: "100%", width: "100%" }}
          />
        </div>
      </div>

    </div>
  );
};

export default TrendingPage;